<template>
    <div class="partner-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>商务合作</h1>
                <p class="English">Cooperation</p>
            </div>
        </div>
        <div class="describe-part part">
            <div class="container">
                <p class="part-title">和探物开启新租赁经济</p>
                <p class="h2">从采购、租赁、归还、维护，到产品的残值处理，形成完整的生态闭环</p>
                <ul class="describe-list">
                    <li  v-for="(item,index) in describeData" class="vertical-top" :key="index">
                        <!-- <img src="~@assets/img/partner/partner-01.png"> -->
                        <!-- <span class="image block bg-contain" ></span> -->
                        <img class="image" :src="item.image">
                        <p class="name">{{item.title}}</p>
                        <p class="desc">
                            {{item.content}} 
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="demo-part part">
            <div class="container">
                <p class="part-title">合作案例</p>
            </div>
            <swiper :options="swiperOption" class="demo-list">
                <swiper-slide v-for="(item,index) in demoData" class="demo-item" :key="index">
                    <div class="image">
                        <img class="block width-full" :src="item.image" alt="test">
                    </div>
                    <p class="title line-ellipsis">{{item.title}}</p>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="my-swiper-prev" slot="button-prev">
                    <img class="block width-full" src="~@assets/img/slide-right-white.png" >
                </div>
                <div class="my-swiper-next" slot="button-next">
                     <img class="block width-full" src="~@assets/img/slide-right-white.png" >
                </div>
            </swiper>
        </div>
        <div class="partner-part part">
            <div class="container">
                <p class="part-title">合作伙伴</p>
                <partnerBox></partnerBox>
            </div>
        </div>
        <div class="contact-part">
            <div class="container">
                <p class="part-title">联系我们</p>
                <p class="h3">直接联系</p>
                <div class="flex font-bold flex-align-end">
                    <span>商务负责人</span>
                    <!-- <span class="person">季龙</span> -->
                    <!-- <p class="info flex flex-align-center">
                        <img class="icon" src="~@assets/img/partner-phone.png" alt="手机号">
                        <span>135 3638 8294</span>
                    </p> -->
                    <p class="info flex flex-align-center">
                        <img class="icon" src="~@assets/img/partner-email.png" alt="邮箱">
                        <a href="mailto:bd@tanwuapp.com">bd@tanwuapp.com</a>
                    </p>
                </div>
                <p class="h3" style="margin-top:60px">或填写您的信息</p>
                <ul class="info-list display-flex-between">
                    <li class="display-flex-between" :class="{warning:companyFlag}">
                        <label>公司/姓名</label>
                        <input type="text" maxlength="100" v-model.trim="askData.company">
                    </li>
                    <li class="display-flex-between" :class="{warning:phoneFlag}">
                        <label>电话</label>
                        <input type="text"  maxlength="50" v-model="askData.phone" oninput = "value=value.replace(/[^\d]/g,'')">
                    </li>
                    <li class="display-flex-between" :class="{warning:emailFlag}">
                        <label>邮箱</label>
                        <input type="text" maxlength="50" v-model.trim="askData.email">
                    </li>
                </ul>
                <div class="flex font-bold flex-align-center">
                    <span>合作主题</span>
                    <ul class="theme-list flex">
                        <li class="flex flex-align-center select-point" v-for="(item,index) in themeList" :key="index" @click="item.isChecked = !item.isChecked">
                            <span class="checkbox" :class="{active:item.isChecked}"></span>
                            <span>{{item.name}}</span>
                        </li>
                        <li class="tip" v-if="titleFlag && !themeList.some(item => item.isChecked)">
                            请选择主题
                        </li>
                    </ul>
                </div>
                <span class="btn normal-btn" :data-text = "successFlag ? '已成功提交' : '确认提交'" @click="submit"></span>
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import partnerBox from '@components/partnerBox';
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
		data() {
			return {
                askData:{
                    company:'',
                    phone:'',
                    title:'',
                    email:'',
                    content:'联系信息'
                },
                companyFlag:false,
                phoneFlag:false,
                emailFlag:false,
                titleFlag:false,
                successFlag:false,
                themeList:[{isChecked:false,name:'产品托管租赁'},{isChecked:false,name:'线上资源合作'},{isChecked:false,name:'线下场景合作'},{isChecked:false,name:'其它合作形式'}],
                swiperOption:{
                    loop:true,
                    slidesPerView: 2,
                    spaceBetween: 30,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.my-swiper-next',
                        prevEl: '.my-swiper-prev'
                    }
                },
                describeData:[
                    {
                        image:'https://resource.tanwuapp.com/FtorVPX2ApQ-UJM-dytEwWWzHOrA',
                        title:'蚂蚁金服投后企业',
                        content:'作为探物的投资方，蚂蚁金服带来风控、流量、供应链金融等多方面的资源支持，以及强大的信用背书'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FoULR2ckUF7RFXR5TEhxPA0-giDx',
                        title:'多平台推广矩阵',
                        content:'探物拥有支付宝、微信、淘宝、飞猪、探物APP、官网、H5等多平台，充分将你的品牌价值放大'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FkSJHf-jjBGyw0qPVnBDqaJi28CU',
                        title:'精准风控超低坏账',
                        content:'基于人工智能算法、用户行为画像、人机识别、团伙检测等多项AI技术，有效识别欺诈行为'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FgR8zqN1hLIsIETzWWI4q0HzSzOJ',
                        title:'数千万用户获取',
                        content:'探物平台触达的用户高达数千万，可快速让你的品牌曝光、增强用户对你的品牌感知度'
                    },
                    {
                        image:'https://resource.tanwuapp.com/Fug-oLhur5dmJtOIvezZPZPEmdiB',
                        title:'巨头流量倾斜',
                        content:'探物与支付宝、闲鱼、淘宝等巨头深度合作，将自身的巨量活跃用户引入探物体系成功开拓新服务版块'
                    },
                    {
                        image:'https://resource.tanwuapp.com/Ftwb0lXTvVxw7RsdO5la_nfxDsYu',
                        title:'完整租赁闭环',
                        content:'探物拥有完整的上下游供应链，从采购、租赁、归还、维护，甚至到产品最后的残值处理的生态闭环'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FnX2C3ULxn3vC5lwqoTCbXDIeQpB',
                        title:'优质用户群体',
                        content:'通过多年的积累，探物拥有独立的品牌认知度，用户的粘度和忠诚度极高，用户的营销价值更高。'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FqMWoD2CYsv7txWpb57B1tPSpVno',
                        title:'多场景租赁需求',
                        content:'探物用户高频的租赁场景有：节假日出行旅游、手机换新、演出活动、专业爱好者'
                    },
                ],
                demoData:[
                    {
                        image:'https://resource.tanwuapp.com/FoGYWIqda6yH_EcBL_Wtbkm83t3L',
                        title:'探物助力华硕开拓高端游戏电脑和高性能游戏显卡的租赁新模式'
                    },
                    {
                        image:'https://resource.tanwuapp.com/Fr9ZP7Edt3oH1dyf9Qr2GUuTI84V',
                        title:'探物受邀蘑菇街APP，开拓信用租赁新模块'
                    },
                    {
                        image:'https://resource.tanwuapp.com/FnGHl1IB6hE86doQisvYD3ef22lN',
                        title:'探物选定为阿里巴巴体系闲鱼租品牌指定租赁服务方'
                    },
                ]
			}
        },
        components: {
            partnerBox,
            swiper,
            swiperSlide,
		},
        created(){
        },
        methods:{
            submit(){
                let askData = this.askData;
                let regPhone = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/; 
                let regEmail = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                this.companyFlag = !askData.company;
                this.phoneFlag = !askData.phone || !regPhone.test(askData.phone);
                this.emailFlag = !askData.email || !regEmail.test(askData.email);
                this.titleFlag = !this.themeList.some(item => item.isChecked);
                if(this.companyFlag || this.phoneFlag || this.emailFlag || this.titleFlag) return;
                askData.title = this.themeList.filter(item => item.isChecked).map(item => item.name).join(',');
                network(CONFIG.contactUs,askData,{
                    method:'POST'
                }).then(res => {
                    // askData.company = '';
                    // askData.phone = '';
                    // askData.email = '';
                    // askData.title = '';
                    this.successFlag = true;
                });
            }
        }
    }
</script>

<style lang="scss">
    .partner-page {
        .public-banner{
            background-image:url('https://resource.tanwuapp.com/FlcaFBUsa0uRaumPefeQ--ZZETeF') ;
        }
        .part-title{
            padding: 50px 0 40px;
            text-align: center;
            font-size: 32px;
            font-weight: bold;
        }
        .describe-part{
            padding-bottom: 54px;
            .part-title{
                padding: 70px 0 10px;
            }
            .h2{
                color: #666666;
                font-size: 18px;
                text-align: center;
                line-height: 30px;
            }
            .describe-list{
                text-align: center;
                padding-top: 40px;
                li{
                    box-sizing: border-box;
                    width: 25%;
                    .image{
                        margin: auto;
                        width: 20%;
                        // padding-bottom: 20%;
                    }
                    .name{
                        font-size: 18px;
                        line-height: 25px;
                        margin-top: 6px;
                        margin-bottom: 14px;
                        font-weight: bold;
                    }
                    .desc{
                        font-size: 14px;
                        color: #666666;
                        text-align: left;
                        height: 138px;
                        margin:0 13.33%;
                    }
                }
            }
        }
        .demo-part{
            padding-bottom: 46px;
            background: #F5F6FA;
            .demo-list{
                padding-bottom: 70px;
                .demo-item{
                    transition: .3s;
                    .image{
                        position: relative;
                        &::before{
                            content: '';
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            transition: background .3s;
                        }
                    }
                    .title{
                        line-height: 1.423;
                        font-size: 24px;
                        font-weight: bold;
                        margin-top: 26px;
                        @media only screen and (max-width: 1200px) {
                            font-size: 18px;
                            margin-top: 20px;
                        }
                    }
                    &.swiper-slide-prev,&.swiper-slide-next{
                        color: #bbbbbb;
                        .image::before{
                            background: rgba($color: #000000, $alpha: 0.5)
                        }
                    }
                }
            }
            .my-swiper-prev,
            .my-swiper-next{
                position: absolute;
                left: 10%;
                top: 37.50%;
                width: 54px;
                height: 54px;
                margin-top: -27px;
                z-index: 10;
                opacity: 0.3;
                transition: opacity 0.3S;
                cursor: pointer;
                &.swiper-button-disabled{
                    opacity: 0.35;
                    cursor: auto;
                    pointer-events: none;
                }
                &:hover{
                    opacity: 1;
                }
            }
            .my-swiper-prev{
                img{
                    transform: rotate(180deg)
                }
            }
            .my-swiper-next{
                left: auto;
                right: 10%;
            }
        }
        .partner-part{
            padding-bottom: 46px;
            background: #ffffff url(~@assets/img/logo/logo-bg.jpg) repeat;
        }
        .contact-part{
            letter-spacing: 1px;
            background: #F5F6FA;
            padding-bottom: 90px;
            white-space: nowrap;
            .h3{
                color: #333333;
                margin-bottom: 20px;
            }
            .person{
                color: #333333;
                font-size: 24px;
                letter-spacing: 6px;
                padding-left: 20px;
                padding-right: 70px;
            }
            .info{
                margin-left: 60px;
                .icon{
                    width: 24px;
                    margin-right: 6px;
                }
            }
            .btn{
                margin-top: 90px;
            }
            .info-list{
                margin-bottom: 30px;
                li{
                    position: relative;
                    width: 30.833%;
                    border-bottom: 2px solid #DDDDDD;
                    padding-bottom: 14px;
                    label{
                        font-weight: bold;
                        margin-right: 10%;
                        white-space: nowrap;
                    }
                    input{
                        flex:1;
                        background: none;
                        outline: none;
                        border: none;
                        font-size: 16px;
                    }
                    &::after{
                        content: '';
                        position: absolute;
                        background: #3ED8C4;
                        height: 2px;
                        left: 0;
                        bottom: -2px;
                        width:100%;
                        transition: transform .3s;
                        transform: scaleX(0);
                        transform-origin: 100% 0;
                    }
                    &:hover::after,&.warning::after{
                        transform: scaleX(1);
                        transform-origin: 0 0;
                    }
                    &.warning::after{
                        background: red;
                    }
                }
            }
            .theme-list{
                margin-left: 60px;
                flex-wrap: wrap;
                li{
                    .checkbox{
                        margin-right: 16px;
                    }
                    &.tip{
                        color: red;
                        font-weight: normal;
                    }
                    &:not(:last-child){
                        margin-right: 60px;
                        @media only screen and (max-width: 1000px) {
                            margin-right: 30px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/partner.vue